import {Table} from 'react-bootstrap';

const SubmissionFormatTable = () => {
 
  return(
    <Table responsive size="md" className="submission-format-table">
      <thead>
        <tr>
          <th>dataset.num</th>
          <th>variable</th>
          <th>level</th>
          <th>year</th>
          <th>satt</th>
          <th>lower90</th>
          <th>upper90</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>0001</td>
          <td>Overall</td>
          <td>NA</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>Overall</td>
          <td>NA</td>
          <td>3</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>Overall</td>
          <td>NA</td>
          <td>4</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X1</td>
          <td>0</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X1</td>
          <td>1</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X2</td>
          <td>A</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X2</td>
          <td>B</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X2</td>
          <td>C</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X3</td>
          <td>0</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X3</td>
          <td>1</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X4</td>
          <td>A</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X4</td>
          <td>B</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X4</td>
          <td>C</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X5</td>
          <td>0</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0001</td>
          <td>X5</td>
          <td>1</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>0002</td>
          <td>Overall</td>
          <td>NA</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
        <tr>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
        </tr>
        <tr>
          <td>3400</td>
          <td>X5</td>
          <td>1</td>
          <td>NA</td>
          <td>.</td>
          <td>.</td>
          <td>.</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default SubmissionFormatTable;
